import type { MascotJobResponse } from './getMascot';
import apiRequest from './apiRequest';

export type MascotsByBatchResponse = {
  items: MascotJobResponse[];
  nextToken?: string;
};

export default async function getMascotsByBatch(
  batchID: string,
  apiKey: string,
  nextToken?: string,
) {
  const params = nextToken ? `?nextToken=${encodeURIComponent(nextToken)}` : '';

  return await apiRequest<MascotsByBatchResponse>(
    'external-mogen',
    `/mascots/${batchID}${params}`,
    {
      method: 'GET',
      headers: {
        'x-api-key': apiKey,
      },
    },
  );
}
